import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/services/auth.service';
import { ScreeningDraft } from 'src/app/models/screeningDraft';
import { environment } from 'src/environments/environment';
import { SearchFee } from 'src/app/packages-module/models/searchPackage';
import { EndUserCertification, ApplicantDocument, Screening } from 'src/app/models/screeningInvite';
import { EmployerVerificationData, ReferenceVerificationData } from 'src/app/models/ApplicantDataResponses/ApplicantDataResponses';
import { Observable } from 'rxjs';
import { FileTransferPayload } from 'src/app/models/FileTransferPayload';
import { ClientPackagePricing } from 'src/app/packages-module/models/clientPackagePrice';

@Injectable({
  providedIn: 'root'
})
export class ScreeningDraftService {
  public _directOrderDemographics: ScreeningDraft;
  public convertedDraft : Screening;
  public clientPackageOverrides: ClientPackagePricing[] = [];
  public additionalFees: SearchFee[];
  public draftsList: Array<ScreeningDraft>;

  public get directOrderDemographics() : ScreeningDraft {
    return this._directOrderDemographics;
  }
  
  public set directOrderDemographics(v : ScreeningDraft) {
    this._directOrderDemographics = Object.assign(new ScreeningDraft(),v);
  }

  constructor(public http: HttpClient,
    public toast: ToastrService,
    private auth: AuthService) { }

    // Save/Update draft 
    SaveDraft(draft: ScreeningDraft) {
      return this.http.post(environment.baseURl + '/api/screeningdraft', draft);
    }

    FetchDrafts() {
      return this.http.get<ScreeningDraft[]>(environment.baseURl  + '/api/screeningdraft/fetch');
    }

    FetchECForDraft(){
      return this.http.get<EndUserCertification>(environment.baseURl  + `/api/screeningdraft/electronic-consent/${this.directOrderDemographics.id}`);
    }

    SaveEmploymentVerification(ver: EmployerVerificationData) : Observable<EmployerVerificationData> {
      return this.http.post<EmployerVerificationData>(environment.baseURl + `/api/screeningdraft/employment`, ver);
    }

    FetchEmploymentDataForDraft(){
      return this.http.get<EmployerVerificationData>(environment.baseURl  + `/api/screeningdraft/employment/${this.directOrderDemographics.id}`);
    }

    SaveResVerification(ver: ReferenceVerificationData){
      return this.http.post<ReferenceVerificationData>(environment.baseURl + `/api/screeningdraft/residence`, ver);
    }

    FetchReferenceDataForDraft(){
      return this.http.get<ReferenceVerificationData>(environment.baseURl  + `/api/screeningdraft/residence/${this.directOrderDemographics.id}`);
    }

    FetchSupportingDocsForDraft(){
      return this.http.get<ApplicantDocument[]>(environment.baseURl  + `/api/screeningdraft/docs/${this.directOrderDemographics.id}`);
    }

    UploadSupportingDoc(ftp : FileTransferPayload) {
      return this.http.post<number>(environment.baseURl + `/api/screeningdraft/docs`, ftp);
    }

    ConvertDraftToReport(){
      return this.http.post<Screening>(environment.baseURl + `/api/screeningdraft/convert`, this.directOrderDemographics);
    }

    CreateNetsuiteInvoiceForDraft()
    {
      return this.http.post<any>(environment.baseURl + `/api/screeningdraft/pos`, this.directOrderDemographics);
    }

}
